import script from "./exportList.vue?vue&type=script&setup=true&lang=js"
export * from "./exportList.vue?vue&type=script&setup=true&lang=js"

import "./exportList.vue?vue&type=style&index=0&id=620c503a&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-620c503a"]])

export default __exports__